/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Checkbox,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import WaitingDialog from "../../utils/WaitingDialog";
import Visibility from "@mui/icons-material/Visibility";
import { useEffect, useState, useMemo } from "react";
import { getCacheData } from "../../services/CacheService";
import MUIDataTable from "mui-datatables";
import RangoDialog from "./RangoDialog";
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  id: "",
  id_articulo: "",
  codigoArticulo: "",
  descripcionArticulo: "",
  modeloArticulo: "",
  cantidad: 0,
  actualCosto: 0,
  valorDolarActual: 0,
  valorDolarUltimo: 0,
  costoActualEnDolar: 0,
  porcentajeDescuento: 0,
  costoReal: 0,
  total: 0,
  idTipoAjuste: "",
  descripcion: "",
  tipoAjuste: "",
  descripcionAjusteArticulo: "",
  idOjo: "",
  idBlCrAdiciones: [],
  idBlCrDiametros: [],
};

const ojoOptions = [
  {
    id: "izquierdo",
    label: "IZQUIERDO"
  },
  {
    id: "derecho",
    label: "DERECHO"
  },
  {
    id: "indistinto",
    label: "INDISTINTO"
  },
];

const nameItemText = "Cristal";
const itemGender = "M";
let actionCrudDescription = "";
//
// ########################################################################### 
//
const IngresoCristalDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [itemCrudLocalRango, setItemCrudLocalRango] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [enableSave, setEnableSave] = useState(false)
  const [cristalProductos, setCristalProductos] = useState([])
  const [blCrAdiciones, setBlCrAdiciones] = useState([])
  const [blCrDiametros, setBlCrDiametros] = useState([])
  const [rangosList, setRangosList] = useState([])
  const [openRangosDialog, setOpenRangosDialog] = useState(false);
  const [actionRangos, setActionRangos] = useState("");
  const [valueACCristalProducto, setValueACCristalProducto] = useState({ id: "", descripcion: "" })
  const [
    inputValueACCristalProducto,
    setInputValueACCristalProducto]
    = useState("");
  const [valueACOjo, setValueACOjo] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACOjo, setInputValueACOjo] = useState("");
  const [valueACBlCrAdicion, setValueACBlCrAdicion] = useState([]);
  const [inputValueACBlCrAdicion, setInputValueACBlCrAdicion] = useState("");
  const [valueACBlCrDiametro, setValueACBlCrDiametro] = useState([]);
  const [inputValueACBlCrDiametro, setInputValueACBlCrDiametro] = useState("");
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [newRango, setNewRango] = useState(false)
  //
  // ################################################################################ 
  // 
  const adicionesOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...blCrAdiciones,
    ];
  }, [blCrAdiciones]);

  const allAdicionesSelected = useMemo(() => {
    return (
      Array.isArray(blCrAdiciones) &&
      blCrAdiciones.length > 0 &&
      Array.isArray(valueACBlCrAdicion) &&
      valueACBlCrAdicion.length === blCrAdiciones.length
    );
  }, [blCrAdiciones, valueACBlCrAdicion]);
  const diametrosOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...blCrDiametros,
    ];
  }, [blCrDiametros]);

  const allDiametrosSelected = useMemo(() => {
    return (
      Array.isArray(blCrDiametros) &&
      blCrDiametros.length > 0 &&
      Array.isArray(valueACBlCrDiametro) &&
      valueACBlCrDiametro.length === blCrDiametros.length
    );
  }, [blCrDiametros, valueACBlCrDiametro]);
  const tableColumnsRangosList = [
    {
      name: "id",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "esfera_desde",
      label: "Esfera Desde",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: "center",
            fontSize: "0.9em",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let _val = rangosList[dataIndex].esfera_desde;
          _val = _val ? _val : "0";
          return _val;
        },
      },
    },
    {
      name: "esfera_hasta",
      label: "Esfera Hasta",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: "center",
            fontSize: "0.9em",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let _val = rangosList[dataIndex].esfera_hasta;
          _val = _val ? _val : "0";
          return _val;
        },
      },
    },
    {
      name: "cilindro_desde",
      label: "Cilindro Desde",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: "center",
            fontSize: "0.9em",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let _val = rangosList[dataIndex].cilindro_desde;
          _val = _val ? _val : "0";
          return _val;
        },
      },
    },
    {
      name: "cilindro_hasta",
      label: "Cilindro Hasta",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: "center",
            fontSize: "0.9em",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let _val = rangosList[dataIndex].cilindro_hasta;
          _val = _val ? _val : "0";
          return _val;
        },
      },
    },
    {
      name: "actions",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        empty: true,
        // display: actionCrud !== "disable" ? true : "excluded",
        setCellProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          // if (actionCrud !== "disable") {
          return (
            <>
              {(actionCrud === "new" || actionCrud === "update") && (
                <Tooltip title="Editar Rango">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => handleClickRango(rangosList[dataIndex], "update")}
                  >
                    <EditOutlinedIcon />
                  </IconButton>
                </Tooltip>
              )}
              {(actionCrud === "new" || actionCrud === "update") && (
                <Tooltip title="Quitar Rango">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => handleClickRango(rangosList[dataIndex], "delete")}
                  >
                    <RemoveCircleOutlineOutlinedIcon />
                  </IconButton>
                </Tooltip>
              )}
              {(actionCrud === "view" || actionCrud === "delete") && (
                <Tooltip title="Ver Rango">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => handleClickRango(rangosList[dataIndex], "view")}
                  >
                    <Visibility />
                  </IconButton>
                </Tooltip>
              )}
            </>
          );
          // }
        }
      },
    },
  ];

  const tableOptionsRangosList = {
    download: false,
    filter: false,
    print: false,
    search: false,
    viewColumns: false,
    elevation: 5,
    // Controls the visibility of the Select Toolbar
    selectToolbarPlacement: "none",
    // Show/hide the select all/deselect all checkbox header for selectable rows
    selectableRowsHeader: false,
    // Hides the checkboxes that appear when selectableRows is set to "multiple" or "single"
    selectableRowsHideCheckboxes: false,
    // Indicates if rows can be selected. Options are "multiple", "single", "none"
    selectableRows: "none",
    rowsPerPageOptions: [10, 20, 30],
    serverSide: true,
    textLabels: {
      body: {
        noMatch: "",
      },
      pagination: {
        next: "Próxima",
        previous: "Previa",
        rowsPerPage: "Filas:",
        displayRows: "de",
      },
    },
    // quitar paginacion de la tabla
    pagination: false,
  };
  //
  // ################################################################################ 
  // cuando se carga el componente
  useEffect(() => {
    loadCristalProductos();
    loadBlCrAdiciones();
    loadBlCrDiametros();
    let _rangosList = [];
    setItemCrudLocal(itemCrud)
    if (actionCrud === "new") {
      actionCrudDescription = "Ingresar"
      setEnableSave(true)
    } else if (actionCrud === "view" || actionCrud === "update" || actionCrud === "delete") {
      if (actionCrud === "update") {
        actionCrudDescription = "Editar"
      } else if (actionCrud === "delete") {
        actionCrudDescription = "Eliminar"
      }
      setEnableSave(true)
      setValueACCristalProducto(
        {
          id: itemCrud.idCristalProducto,
          label: itemCrud.descripcionCristalProducto,
        }
      )
      setInputValueACCristalProducto(itemCrud.descripcionCristalProducto);
      setValueACOjo(
        {
          id: itemCrud.ojo,
          label: itemCrud.ojo ? itemCrud.ojo.toUpperCase() : "",
        }
      )
      setInputValueACOjo(itemCrud.ojo ? itemCrud.ojo.toUpperCase() : "");

      _rangosList = itemCrud.rangosList;
      setRangosList(_rangosList);
    }
    else if (actionCrud === "view") {
      actionCrudDescription = "Ver"
    }

  }, []);

  //
  // ################################################################################
  //
  useEffect(() => {
    if ((actionCrud === "update" || actionCrud === "delete" || actionCrud === "view") && Array.isArray(blCrAdiciones) && blCrAdiciones.length > 0) {
      const sourceList = itemCrud?.adicionesList || itemCrud?.idBlCrAdiciones || [];
      if (Array.isArray(sourceList) && sourceList.length > 0) {
        const selectedIds = sourceList
          .map((it) => {
            if (it && typeof it === 'object') {
              return it.id_bl_cr_adicion || it.id;
            }
            return it;
          })
          .filter(Boolean);
        const selectedOptions = blCrAdiciones.filter(opt => selectedIds.includes(opt.id));
        if (selectedOptions.length > 0) {
          setValueACBlCrAdicion(selectedOptions);
        }
      }
    }
  }, [actionCrud, itemCrud, blCrAdiciones]);

  //
  // ################################################################################
  //
  useEffect(() => {
    if ((actionCrud === "update" || actionCrud === "delete" || actionCrud === "view") && Array.isArray(blCrDiametros) && blCrDiametros.length > 0) {
      const sourceList = itemCrud?.diametrosList || itemCrud?.idBlCrDiametros || [];
      if (Array.isArray(sourceList) && sourceList.length > 0) {
        const selectedIds = sourceList
          .map((it) => {
            if (it && typeof it === 'object') {
              return it.id_bl_cr_diametro || it.id;
            }
            return it;
          })
          .filter(Boolean);
        const selectedOptions = blCrDiametros.filter(opt => selectedIds.includes(opt.id));
        if (selectedOptions.length > 0) {
          setValueACBlCrDiametro(selectedOptions);
        }
      }
    }
  }, [actionCrud, itemCrud, blCrDiametros]);

  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACCristalProducto.id !== "" && valueACCristalProducto.id !== null && valueACCristalProducto.id !== undefined &&
      valueACOjo.id !== "" && valueACOjo.id !== null && valueACOjo.id !== undefined &&
      Array.isArray(valueACBlCrAdicion) && valueACBlCrAdicion.length > 0 &&
      Array.isArray(valueACBlCrDiametro) && valueACBlCrDiametro.length > 0 &&
      Array.isArray(rangosList) && rangosList.length > 0 ||
      newRango
    ) {
      setEnableSave(true);
    } else {
      setEnableSave(false);
    }
  }, [valueACCristalProducto, valueACOjo, valueACBlCrAdicion, valueACBlCrDiametro, rangosList, newRango])

  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSaveRango = (itemCrud, action) => {
    let _rangosList = rangosList;
    setNewRango(false);
    if (action === "update") {
      _rangosList.forEach(item => {
        if (item.id === itemCrud.id) {
          item.esfera_desde = itemCrud.esferaDesde;
          item.esfera_hasta = itemCrud.esferaHasta;
          item.cilindro_desde = itemCrud.cilindroDesde;
          item.cilindro_hasta = itemCrud.cilindroHasta;
        }
      });
    } else if (action === "delete") {
      _rangosList = _rangosList.filter(item => item.id !== itemCrud.id);
      setRangosList(_rangosList);
    } else if (action === "new") {
      // generar un id
      itemCrud.id = uuidv4();
      setNewRango(true);
      let obj = {
        id: itemCrud.id,
        esfera_desde: itemCrud.esferaDesde,
        esfera_hasta: itemCrud.esferaHasta,
        cilindro_desde: itemCrud.cilindroDesde,
        cilindro_hasta: itemCrud.cilindroHasta,
      };
      _rangosList.push(obj);
      setRangosList(_rangosList);
    }

    if (action !== "new") {
      setOpenRangosDialog(false);
    }
    setRangosList(_rangosList);
  };
  // ################################################################################
  //
  const handleCloseRangoDialog = () => {
    setOpenRangosDialog(false);
  };
  //
  // ################################################################################
  //
  const handleClickRango = (itemCrud, action) => {
    if (action === "delete") {
      const _rangosList = rangosList.filter((it) => it.id !== itemCrud.id);
      setRangosList(_rangosList);
      setMessage({
        severity: "success",
        messageText: "Rango quitado correctamente",
      });
      setShowMessage(true);
      return;
    } else if (action !== "view" && action !== "delete") {
      setOpenRangosDialog(true);
      setActionRangos(action);
      setItemCrudLocalRango(itemCrud);
      return;
    } else if (action === "view") {
      setOpenRangosDialog(true);
      setActionRangos(action);
      setItemCrudLocalRango(itemCrud);
      return;
    }
  };
  //
  // ################################################################################ 
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (valueACCristalProducto.id === "" || valueACCristalProducto.id === null || valueACCristalProducto.id === undefined) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Producto",
        });
        setShowMessage(true);
        return;
      }
      if (valueACOjo.id === "" || valueACOjo.id === null || valueACOjo.id === undefined) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Ojo",
        });
        setShowMessage(true);
        return;
      }
      const selectedAdicionesCount = Array.isArray(valueACBlCrAdicion) ? valueACBlCrAdicion.length : 0;
      const existingAdicionesCount = (itemCrudLocal.adicionesList && itemCrudLocal.adicionesList.length) || (itemCrudLocal.idBlCrAdiciones && itemCrudLocal.idBlCrAdiciones.length) || 0;
      if (selectedAdicionesCount === 0 && existingAdicionesCount === 0) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar al menos una Adición",
        });
        setShowMessage(true);
        return;
      }
      const selectedDiametrosCount = Array.isArray(valueACBlCrDiametro) ? valueACBlCrDiametro.length : 0;
      const existingDiametrosCount = (itemCrudLocal.diametrosList && itemCrudLocal.diametrosList.length) || (itemCrudLocal.idBlCrDiametros && itemCrudLocal.idBlCrDiametros.length) || 0;
      if (selectedDiametrosCount === 0 && existingDiametrosCount === 0) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar al menos un Diámetro",
        });
        setShowMessage(true);
        return;
      }
      if (rangosList.length === 0) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar al menos un Rango",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {
    let _itemCrud = {};

    if (actionCrud === "new") {
      _itemCrud = {
        id: uuidv4(),
        idCristalProducto: valueACCristalProducto.id,
        descripcionCristalProducto: valueACCristalProducto.label,
        adicionesList: valueACBlCrAdicion.map(a => ({
          id_bl_cr_adicion: a.id,
        })),
        diametrosList: valueACBlCrDiametro.map(d => ({
          id_bl_cr_diametro: d.id,
        })),
        ojo: valueACOjo.id,
        rangosList: rangosList.map(r => ({
          esfera_desde: r.esfera_desde,
          esfera_hasta: r.esfera_hasta,
          cilindro_desde: r.cilindro_desde,
          cilindro_hasta: r.cilindro_hasta,
        })),
        observaciones: itemCrudLocal.observaciones?.toUpperCase() || "",

      }
    } else {
      _itemCrud = {
        id: itemCrudLocal.id,
        idCristalProducto: itemCrudLocal.idCristalProducto,
        descripcionCristalProducto: itemCrudLocal.descripcionCristalProducto,
        adicionesList: valueACBlCrAdicion.map(a => ({
          id_bl_cr_adicion: a.id,
        })),
        diametrosList: valueACBlCrDiametro.map(d => ({
          id_bl_cr_diametro: d.id,
        })),
        ojo: itemCrudLocal.ojo,
        rangosList: rangosList.map(r => ({
          esfera_desde: r.esfera_desde,
          esfera_hasta: r.esfera_hasta,
          cilindro_desde: r.cilindro_desde,
          cilindro_hasta: r.cilindro_hasta,
        })),
        observaciones: itemCrudLocal.observaciones,
      }
    }
    onSave(_itemCrud, actionCrud);
  };
  //
  // ##########################################################################
  //
  const handleSelectAllAdiciones = () => {
    if (Array.isArray(blCrAdiciones) && blCrAdiciones.length > 0) {
      setValueACBlCrAdicion(blCrAdiciones);
    }
  };

  const handleClearAllAdiciones = () => {
    setValueACBlCrAdicion([]);
  };
  //
  // ##########################################################################
  //
  const handleSelectAllDiametros = () => {
    if (Array.isArray(blCrDiametros) && blCrDiametros.length > 0) {
      setValueACBlCrDiametro(blCrDiametros);
    }
  };
  //
  // ##########################################################################
  //
  const handleClearAllDiametros = () => {
    setValueACBlCrDiametro([]);
  };
  //
  // ################################################################################
  //
  const loadCristalProductos = async () => {
    const response = await getCacheData("cristal_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCristalProductos(_var);
    } else {
      setCristalProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const loadBlCrAdiciones = async () => {
    const response = await getCacheData("bl_cr_adicion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCrAdiciones(_var);
    } else {
      setBlCrAdiciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const loadBlCrDiametros = async () => {
    setIsDoingSomething(true);
    const response = await getCacheData("bl_cr_diametro");
    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(0),
        });
      });
      setBlCrDiametros(_var);
    } else {
      setIsDoingSomething(false);
      setBlCrDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleCloseDialog();
        }}
        maxWidth="lg"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrudDescription} {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box >
            <Box
              sx={{
                m: 1,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} justifyContent="center" >
                <Grid item xs={12} md={12} lg={9}>
                  <Autocomplete
                    id="id-cristal-producto"
                    size="small"
                    sx={{ width: "100%" }}
                    value={
                      valueACCristalProducto && valueACCristalProducto.id
                        ? valueACCristalProducto
                        : null
                    }
                    onChange={(event, newValue) => {
                      setValueACCristalProducto(newValue);
                      setItemCrudLocal({
                        ...itemCrudLocal,
                        idCristalProducto: newValue ? newValue.id : "",
                        descripcionCristalProducto: newValue ? newValue.label : "",
                      });
                    }}
                    inputValue={inputValueACCristalProducto}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACCristalProducto(newInputValue);
                    }}
                    options={cristalProductos}
                    getOptionLabel={(option) => option.label || ""}
                    renderInput={(params) => <TextField {...params} label="Producto" />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable" || actionCrud === "delete"}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={9} justifyContent="center">
                  <Autocomplete
                    id="id-ojo"
                    size="small"
                    sx={{ width: "100%" }}
                    value={
                      valueACOjo && valueACOjo.id
                        ? valueACOjo
                        : null
                    }
                    onChange={(event, newValue) => {
                      setValueACOjo(newValue);
                      setItemCrudLocal({
                        ...itemCrudLocal,
                        ojo: newValue ? newValue.id : "",
                      });
                    }}
                    inputValue={inputValueACOjo}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACOjo(newInputValue);
                    }}
                    options={ojoOptions}
                    getOptionLabel={(option) => option.label || ""}
                    renderInput={(params) => <TextField {...params} label="Ojo" />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable" || actionCrud === "delete"}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={4.5} justifyContent="center">
                  <Autocomplete
                    id="id-bl-cr-adicion"
                    size="small"
                    sx={{ width: "100%" }}
                    multiple
                    limitTags={5}
                    openOnFocus
                    disableCloseOnSelect // 
                    value={valueACBlCrAdicion || []}
                    onChange={(event, newValue, reason, details) => {
                      const lastOption = details && details.option ? details.option : null;
                      if (lastOption && lastOption.__action) {
                        if (allAdicionesSelected) {
                          handleClearAllAdiciones();
                        } else {
                          handleSelectAllAdiciones();
                        }
                        return;
                      }
                      setValueACBlCrAdicion(newValue);
                    }}
                    inputValue={inputValueACBlCrAdicion}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACBlCrAdicion(newInputValue);
                    }}
                    options={adicionesOptionsWithActions}
                    isOptionEqualToValue={(option, value) => {
                      if (!option || !value) return false;
                      if (option.__action || value.__action) return option.id === value.id;
                      return option.id === value.id;
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    renderTags={(selected, getTagProps) => {
                      const visibleChips = 3;
                      const chips = selected.slice(0, visibleChips).map((option, index) => (
                        <Chip
                          {...getTagProps({ index })}
                          key={option.id}
                          label={option.label}
                          size="small"
                        />
                      ));
                      if (selected.length > visibleChips) {
                        chips.push(
                          <Chip key="more" label={`+${selected.length - visibleChips}`} size="small" disabled />
                        );
                      }
                      return chips;
                    }}
                    disableClearable={true}
                    disabled={
                      actionCrud === "view" ||
                      actionCrud === "enable" ||
                      actionCrud === "disable" ||
                      actionCrud === "delete"
                    }
                    renderOption={(props, option, { selected }) => {
                      if (option.__action) {
                        return (
                          <li {...props}>
                            <Checkbox
                              indeterminate={
                                !allAdicionesSelected &&
                                Array.isArray(valueACBlCrAdicion) &&
                                valueACBlCrAdicion.length > 0
                              }
                              checked={allAdicionesSelected}
                              style={{ marginRight: 5 }}
                            />
                            {allAdicionesSelected ? "Desmarcar todos" : "Marcar todos"}
                          </li>
                        );
                      }
                      return (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 5 }}
                            checked={selected}
                          />
                          {option.label}
                        </li>
                      );
                    }}
                    renderInput={(params) => <TextField {...params} label="Adiciones" />}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={4.5} justifyContent="center">
                  <Autocomplete
                    id="id-bl-cr-diametro"
                    size="small"
                    sx={{ width: "100%" }}
                    multiple
                    limitTags={5}
                    openOnFocus
                    disableCloseOnSelect
                    value={valueACBlCrDiametro || []}
                    onChange={(event, newValue, reason, details) => {
                      const lastOption = details && details.option ? details.option : null;
                      if (lastOption && lastOption.__action) {
                        if (allDiametrosSelected) {
                          handleClearAllDiametros();
                        } else {
                          handleSelectAllDiametros();
                        }
                        return;
                      }
                      setValueACBlCrDiametro(newValue);
                    }}
                    inputValue={inputValueACBlCrDiametro}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACBlCrDiametro(newInputValue);
                    }}
                    options={diametrosOptionsWithActions}
                    isOptionEqualToValue={(option, value) => {
                      if (!option || !value) return false;
                      if (option.__action || value.__action) return option.id === value.id;
                      return option.id === value.id;
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    renderTags={(selected, getTagProps) => {
                      const visibleChips = 3;
                      const chips = selected.slice(0, visibleChips).map((option, index) => (
                        <Chip
                          {...getTagProps({ index })}
                          key={option.id}
                          label={option.label}
                          size="small"
                        />
                      ));
                      if (selected.length > visibleChips) {
                        chips.push(
                          <Chip key="more" label={`+${selected.length - visibleChips}`} size="small" disabled />
                        );
                      }
                      return chips;
                    }}
                    disableClearable={true}
                    disabled={actionCrud === "view" || actionCrud === "enable" || actionCrud === "disable" || actionCrud === "delete"}
                    renderOption={(props, option, { selected }) => {
                      if (option.__action) {
                        return (
                          <li {...props}>
                            <Checkbox
                              indeterminate={
                                !allDiametrosSelected &&
                                Array.isArray(valueACBlCrDiametro) &&
                                valueACBlCrDiametro.length > 0
                              }
                              checked={allDiametrosSelected}
                              style={{ marginRight: 5 }}
                            />
                            {allDiametrosSelected ? "Desmarcar todos" : "Marcar todos"}
                          </li>
                        );
                      }
                      return (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 5 }}
                            checked={selected}
                          />
                          {option.label}
                        </li>
                      );
                    }}
                    renderInput={(params) => <TextField {...params} label="Diámetros" />}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <Grid container spacing={1} >
                {(actionCrud === "new" || actionCrud === "update") && (
                  <Grid item xs={12} md={12} lg={2}>
                    <Button
                      className="btn-add-custom"
                      variant="contained"
                      onClick={() => handleClickRango({}, "new")}
                      size="small"
                      sx={{ mb: 1, pb: 1, mt: 1 }}
                      disabled={isDoingSomething}
                    >
                      Rango
                    </Button>
                  </Grid>
                )}
                <Grid item xs={12} md={12} lg={12}>
                  <Box sx={{ maxHeight: "400px", overflowY: "auto", margin: "center", marginTop: "10px" }}>
                    <MUIDataTable
                      data={rangosList}
                      columns={tableColumnsRangosList}
                      options={{ ...tableOptionsRangosList, responsive: "standard" }}
                      title="Rangos"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                m: 1,
                p: 2,
                pt: 2,
                border: "1px solid LightGrey",
                borderRadius: "5px",
                backgroundColor: "primary",
              }}
              className="box-table"
            >
              <TextField
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                multiline
                rows={3}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px',
                    minWidth: '400px',
                  }
                }}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view" || actionCrud === "delete"}
              />
            </Box>
          </Box>
          <Box
            sx={{
              m: 1,
              p: 2,
              pt: 2,
              border: "1px solid LightGrey",
              borderRadius: "5px",
              backgroundColor: "primary",
            }}
            className="box-table"
          >
            <Grid container justifyContent="flex-end" spacing={1} sx={{ mt: 0 }}>
              {actionCrud !== "view" && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  startIcon={actionCrud === "delete" ? <RemoveCircleOutlineIcon /> : <SaveIcon />}
                  disabled={!enableSave}
                  color={actionCrud === "delete" ? "error" : "primary"}
                >

                  {actionCrud === "delete" ? "Eliminar" : "Guardar"}

                </Button>)}
              <Button
                sx={{ mr: 2 }}
                variant="outlined"
                onClick={handleCloseDialog}
              >
                {actionCrudDescription === "Ver" ? "Cerrar" : "Cancelar"}
              </Button>
            </Grid>
          </Box>
        </DialogContent >
      </Dialog >
      {openRangosDialog && (
        <RangoDialog
          open={openRangosDialog}
          itemCrud={itemCrudLocalRango}
          onCloseRangoDialog={handleCloseRangoDialog}
          actionCrud={actionRangos}
          // necesito pasarmelos rangos
          rangosList={rangosList}
          onSaveRango={handleSaveRango}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default IngresoCristalDialog;
